import { IconProps } from '../../../lib/types';

const CurrentLocation: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <svg
      tabIndex={onClick ? 1 : 0}
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="40.707"
      height="40.707"
      viewBox="0 0 40.707 40.707"
    >
      <path
        d="M36.003 18.092A15.88 15.88 0 0022.615 4.659V0h-4.523v4.659A15.88 15.88 0 004.704 18.092H-.002v4.523h4.7A15.832 15.832 0 0018.092 36v4.7h4.523V36a15.832 15.832 0 0013.388-13.388h4.7v-4.52zm-15.65 13.569a11.308 11.308 0 1111.308-11.308 11.312 11.312 0 01-11.308 11.308z"
        className="a"
      ></path>
      <path
        d="M24.877 20.354a4.523 4.523 0 11-4.523-4.523 4.523 4.523 0 014.523 4.523"
        className="a"
      ></path>
    </svg>
  );
};

export default CurrentLocation;